/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whatsnew_TitleInputs */



/**
* | output |
* | --- |
* | "What's new" |
*
* @param {Whatsnew_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const whatsnew_title = /** @type {((inputs?: Whatsnew_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whatsnew_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveautés")
	if (locale === "es") return /** @type {LocalizedString} */ ("Novedades")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Novidades")
	if (locale === "it") return /** @type {LocalizedString} */ ("Novità")
	return /** @type {LocalizedString} */ ("What's new")
});